import { AppInfo } from "src/types/RequestData"
import { Platform } from "react-native"
import Constants from "expo-constants"

const getOsType = (): "ios" | "android" | "web" => {
  if (Platform.OS === "ios") return "ios"
  if (Platform.OS === "android") return "android"
  return "web"
}

const getOsVersion = (): string => {
  // Web環境ではuserAgentから簡易的にブラウザ情報を取得
  if (Platform.OS === "web") {
    if (typeof navigator !== "undefined" && navigator.userAgent) {
      return navigator.userAgent
    }
    return "unknown"
  }
  // iOS/Androidの場合は従来通り
  return String(Platform.Version)
}

export const appInfo: AppInfo = {
  osType: getOsType(),
  appVersion: Constants.expoConfig?.version || "",
  // https://reactnative.dev/docs/platform-specific-code#platform-module
  // 例: iOS: 15.3.1, Android: 28, Web: UserAgent文字列
  osVersion: getOsVersion(),
}
